import Icon from "@ant-design/icons";

const SinkSvg = () => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.1058 7.99511H16.0763V8.99572C16.0763 9.91554 15.8951 10.8263 15.5431 11.6761C15.1911 12.5259 14.6751 13.2981 14.0246 13.9485C13.3742 14.5989 12.6019 15.1148 11.7521 15.4668C10.9022 15.8188 9.99133 16 9.07144 16H7.07005C5.21224 16 3.43053 15.2621 2.11686 13.9485C0.803195 12.6349 0.0651855 10.8534 0.0651855 8.99572V7.99511H12.1044V3.51719C12.1044 3.31804 12.0651 3.12085 11.9889 2.93688C11.9127 2.7529 11.8009 2.58575 11.66 2.44497C11.5192 2.30419 11.352 2.19254 11.1679 2.1164C10.9839 2.04026 10.7867 2.00112 10.5875 2.00122H10.0834C9.62445 2.00122 9.23621 2.30742 9.11282 2.72723C9.423 2.90506 9.6807 3.16166 9.85986 3.47106C10.039 3.78046 10.1333 4.13169 10.1331 4.48921H6.06935C6.06929 4.13302 6.1629 3.78308 6.34078 3.47448C6.51866 3.16588 6.77457 2.90948 7.08284 2.73099C7.15328 1.98386 7.49994 1.28988 8.05502 0.784799C8.6101 0.279718 9.33366 -0.000128195 10.0842 4.40544e-08H10.5883C11.5212 4.40544e-08 12.4159 0.370559 13.0755 1.03016C13.7352 1.68976 14.1058 2.58437 14.1058 3.51719V7.99511Z"
			fill="currentColor"
		/>
	</svg>
);
export const SinkIcon = props => <Icon component={SinkSvg} {...props} />;
